import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useWorkspace } from '../../context/WorkspaceContext';

// Guards the planning poker entry points. Organizations set to Shape Up only
// get sent to their hill charts instead. Existing sessions stay reachable by
// link so switching methodology never orphans past estimates.
const ScrumRoute = ({ children }) => {
  const { isScrumEnabled, loading } = useWorkspace();
  const location = useLocation();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isScrumEnabled()) {
    return <Navigate to="/shape-up" state={{ from: location }} replace />;
  }

  return children;
};

export default ScrumRoute;
